import { Member } from '../../../../api/groups';

export default function renderStudent(member: Member) {
  const firstName = member.firstName!.length > 3 ? `${member.firstName!.slice(0, 3)}.` : member.firstName;
  const lastName = member.lastName!.length > 3 ? `${member.lastName!.slice(0, 3)}.` : member.lastName;

  return `${lastName} ${firstName}`;
}

export function renderStudentFullName(member: Member) {
  return `${member.lastName} ${member.firstName}`;
}
